import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import AboutPage from 'pages/aboutus'

const MifabAbout = () => {
  return (
    <div className='wrapper'>
        <main id='contentBox'>
          <AboutPage />
        </main>
    </div>
  )
}

export default MifabAbout